import {
  FormControl,
  HStack,
  TextArea,
  TextAreaProps,
} from '@metservicedev/met-ui';
import React from 'react';
import { FieldPath, FieldValues, get, useFormContext } from 'react-hook-form';

import { InfoToolTip } from './InfoToolTip';
import { ValidationMessage } from './ValidationMessage';

type Props<T extends FieldValues> = {
  'data-testid'?: string;
  disabled?: boolean;
  fieldPath: FieldPath<T>;
  helperText?: string;
  label: string;
  tooltipContent?: string;
  textAreaProps?: TextAreaProps;
  formControlProps?: React.ComponentProps<typeof FormControl>;
};

export const FormTextArea = <T extends FieldValues>({
  'data-testid': testId,
  disabled,
  fieldPath,
  label,
  tooltipContent,
  textAreaProps,
  formControlProps,
}: Props<T>): React.ReactElement<Props<T>> => {
  const { formState, register } = useFormContext<T>();
  const error = get(formState.errors, fieldPath);
  return (
    <FormControl
      {...formControlProps}
      disabled={disabled}
      invalid={!!error || undefined}
    >
      <HStack>
        <TextArea
          {...textAreaProps}
          data-testid={testId}
          label={label}
          height="full"
          {...register(fieldPath)}
        />
        {tooltipContent && (
          <InfoToolTip
            tooltipContent={tooltipContent}
            data-testid={`${testId}-tooltip`}
          />
        )}
      </HStack>
      <ValidationMessage message={error?.message && String(error.message)} />
    </FormControl>
  );
};
